import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ServicePage from "@/pages/ServicePage";
import Trainings from "@/pages/Trainings";
import GalleryPage from "@/pages/GalleryPage";
import Membership from "@/pages/Membership";
import Contact from "@/pages/Contact";
import BookingPage from "@/pages/BookingPage";
import NotFound from "@/pages/NotFound";
import { TourPage } from "@/components/site/TourPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/hakkimizda" element={<About />} />
          <Route path="/hizmetler" element={<Navigate to="/egitimlerimiz" replace />} />
          <Route path="/egitimler" element={<Navigate to="/egitimlerimiz" replace />} />
          <Route path="/egitimler/kiralama-tur" element={<Navigate to="/enduro-tur" replace />} />
          <Route path="/enduro-tur" element={<TourPage />} />
          <Route path="/egitimler/:slug" element={<ServicePage />} />
          <Route path="/uyelik" element={<Membership />} />
          <Route path="/egitimlerimiz" element={<Trainings />} />
          <Route path="/galeri" element={<GalleryPage />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/rezervasyon" element={<BookingPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
